module.exports = __webpack_public_path__ + "img/250-sint-eustatius.6706547a.svg";